import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/po-ledger/$poId/_layout/_index/')({
  component: () => null
});